import React from 'react'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import style from './styles.module.scss'

import { BigCalendarHeader } from '../header/BigCalendarHeader'
import { BigCalendarHeaderICalendarImportProps } from '../header/components/BigCalendarHeaderImportButton'
import { BigCalendarModal } from '../modal/BigCalendarModal'
import { BigCalendar, BigCalendarProps } from '../../BigCalendar'
import { BigCalendarMonth, useBigCalendar } from '../../utils/use-big-calendar'
import { SimpleModalProps } from '../../../../../../../atoms'
import { Scrollbars } from '../../../../../../../layout'

type BigCalendarContainerProps = Pick<
  BigCalendarHeaderICalendarImportProps,
  'onUpdateICalendarUrls'
> &
  Pick<BigCalendarProps, 'house'> & {
    modalContent: Pick<SimpleModalProps['content'], 'body' | 'footer'>
  }
export const BigCalendarContainer = (props: BigCalendarContainerProps) => {
  const { house, onUpdateICalendarUrls, modalContent } = props
  const { handleOnScroll, currentMonth, calendarMonths, scrollbarsRef } =
    useBigCalendar()

  const handleOnSelect = (calendarMonth: BigCalendarMonth) => {
    scrollbarsRef.current?.scrollToPositionTop(calendarMonth.offSet)
  }

  return (
    <>
      <BigCalendarHeader
        onChange={handleOnSelect}
        currentMonth={currentMonth}
        house={house}
        onUpdateICalendarUrls={onUpdateICalendarUrls}
      />

      <Scrollbars
        className={style.container}
        onScroll={handleOnScroll}
        ref={scrollbarsRef}
      >
        {calendarMonths.map((calendarMonth) => {
          const { id } = calendarMonth

          return (
            <div id={id} key={id}>
              <BigCalendar {...props} calendarMonth={calendarMonth} />
            </div>
          )
        })}
      </Scrollbars>

      <BigCalendarModal {...modalContent} />
    </>
  )
}
